<template>
  <VDialogV3
    position="right"
    width="600px"

    :entity="localReceipt"

    @submit="onSubmit"
    :submit-disabled="!isValidForSave"
  >
    <section>
      <header>Основное</header>

      <VSelectV2
        v-model="selectedSeller"
        label="Грузоотправитель"
        layout="vertical"
        required
        :disabled="!isNewDocument"
        :data="sellerSource"
      >
        <template #helper-text>
<!--          <template v-if="selectedSeller">-->
<!--            При необходимости вы можете <VLink @click="PartnersService.showPartnerCard(selectedSeller.id)">отредактировать партнера</VLink>-->
<!--          </template>-->
<!--          <template v-else>-->
<!--            При необходимости вы можете <VLink @click="createPartner">cоздать нового партнера</VLink>-->
<!--          </template>-->
        </template>
      </VSelectV2>

      <VSelectV2
        v-model="localReceipt.shipment"
        label="Отгрузка"
        layout="vertical"
        required
        :disabled="!isNewDocument"
        :data="shipmentsSource"
      />

      <VDateInput
        v-model="localReceipt.receiptDate"
        label="Дата приемки"
        layout="vertical"
        required
        :disabled="!localReceipt.shipment"
      />
    </section>
  </VDialogV3>
</template>

<script lang="ts">

import type Partner          from '@/domains/Partners/Partner';
import Receipt               from '@/domains/Receipts/Receipt';
import ShipmentsService      from '@/domains/Shipments/ShipmentsService';
import PartnersService       from '@/domains/Partners/PartnersService';

export default defineComponent({
  name: 'ReceiptRequisites',

  props: {
    receipt: {
      type:    Receipt,
      default: null,
    },
  },

  emits: ['save'],

  data() {
    const isNewDocument = this.$core.utils.isNullOrUndefined(this.receipt?.id);
    const localReceipt  = this.$core.utils.cloneDeepWithReference(this.receipt, ['shipment', 'positions']);

    return {
      isNewDocument,
      localReceipt,
      PartnersService,

      /**
       * Продавец — не реквизит приёмки (он живёт в отгрузке), а фильтр
       * поиска отгрузки, поэтому локальное поле, а не v-model в модель.
       * Повторное открытие — продавец выбранной отгрузки; новая приёмка —
       * пусто: создаёт покупатель, предзаполнять некем.
       */
      selectedSeller: (localReceipt?.shipment?.seller ?? null) as Partner | null,

      sellerSource: this.$core.loader.select(({ pattern }) => PartnersService.searchSellers(pattern)),

      /**
       * Непринятые отгрузки выбранного грузоотправителя. Смена продавца
       * перезагружает список, а отгрузка чужого продавца сбрасывается
       * самим селектом — прежний onSellerChange не нужен.
       */
      shipmentsSource: this.$core.loader.select(({ seller }) => ShipmentsService.getList({
          seller:     { id: seller.id },
          isReceived: false,
        }))
        .dependsOn({ seller: () => this.selectedSeller })
        .preloadOnMount(isNewDocument === true)
        .preloadOnFocus(isNewDocument === false),
    };
  },

  computed: {
    /** Нельзя сохранить без выбранной отгрузки. */
    isValidForSave(): boolean {
      return this.localReceipt.shipment != null;
    },
  },

  methods: {
    onSubmit(): void {
      this.$emit('updated', this.localReceipt);
      this.$core.dialogs.ReceiptRequisites.hide();
    },

    /**
     * Создание партнёра. Созданный подставляется в поле грузоотправителя
     * и сразу открывается на редактирование — при создании заполнено только
     * основное, остальное оператор дозаполняет в карточке.
     */
    async createPartner(): Promise<void> {
      const partner = await PartnersService.createPartner();

      if (partner) {
        this.selectedSeller = await PartnersService.get(partner.id);

        await PartnersService.showPartnerCard(this.selectedSeller);
      }
    },
  },
});
</script>
